import { render, staticRenderFns } from "./EditorUI.vue?vue&type=template&id=2edf922f&scoped=true&"
import script from "./EditorUI.vue?vue&type=script&lang=js&"
export * from "./EditorUI.vue?vue&type=script&lang=js&"
import style0 from "./EditorUI.vue?vue&type=style&index=0&id=2edf922f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2edf922f",
  null
  
)

export default component.exports